import './utils/instrumentOpportunityWrites.js';
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import Router from './Router.js';
import "./index.css";
import reportWebVitals from './reportWebVitals.js';
import { sendToVercelAnalytics } from './vitals.js';
import { ClerkProvider } from "@clerk/clerk-react";
import posthog from 'posthog-js';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import IntercomProvider from './components/IntercomProvider.js';
import { Analytics } from '@vercel/analytics/react';

const isProduction = typeof window !== 'undefined' &&
  !['localhost', '127.0.0.1'].includes(window.location?.hostname || '');

// Only load Vercel Speed Insights when deployed on Vercel (script path /_vercel/speed-insights/ exists there)
const isVercelDeployment = isProduction && (
  (typeof window !== 'undefined' && window.location?.hostname?.includes('vercel.app')) ||
  process.env.REACT_APP_VERCEL === '1'
);

function LazySpeedInsights() {
  const [SpeedInsights, setSpeedInsights] = useState(null);
  useEffect(() => {
    if (!isVercelDeployment) return;
    import('@vercel/speed-insights/react').then((m) => setSpeedInsights(() => m.SpeedInsights));
  }, []);
  return SpeedInsights ? <SpeedInsights /> : null;
}

const posthogKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
if (isProduction && posthogKey) {
	posthog.init(posthogKey, {
		api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
		person_profiles: 'identified_only',
		capture_pageview: true,
		capture_pageleave: true,
	});
}

const clerkPublishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 30 * 60 * 1000, // 30 minutes
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")).render(
	<QueryClientProvider client={queryClient}>
			<ClerkProvider publishableKey={clerkPublishableKey} appearance={{ elements: { footerAction: "hidden", profileSection__danger: "hidden" } }}>
				<IntercomProvider>
					<Router />
					<Analytics />
					{isVercelDeployment && <LazySpeedInsights />}
				</IntercomProvider>
			</ClerkProvider>
	</QueryClientProvider>
	// <React.StrictMode>
		// <ClerkProvider publishableKey={clerkPublishableKey} appearance={{ elements: { footerAction: "hidden", profileSection__danger : "hidden" } }}>
			// <Router />
		// </ClerkProvider>
	// </React.StrictMode>
);

reportWebVitals(isVercelDeployment ? sendToVercelAnalytics : () => {});
